export default __webpack_public_path__ + "static/media/undraw_analysis_.cf15a03f.svg";